/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_VerifyInputs */

const en_signin_verify = /** @type {(inputs: Signin_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const id_signin_verify = /** @type {(inputs: Signin_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Signin_VerifyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_verify = /** @type {((inputs?: Signin_VerifyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_VerifyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_verify(inputs)
	return en_signin_verify(inputs)
});